import { render, staticRenderFns } from "./BasicsConfigMain.vue?vue&type=template&id=87790bc0&"
import script from "./BasicsConfigMain.vue?vue&type=script&lang=js&"
export * from "./BasicsConfigMain.vue?vue&type=script&lang=js&"
import style0 from "./BasicsConfigMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports